import React from "react";
import { BorderContainer } from "../../components/ui/BorderContainer.component";
import Breadcrumb from "../../components/ui/Breadcrumb.component";

export const PaymentPage = () => {
  return (
    <div className="w-[100%]">
      <Breadcrumb
        segments={["Home", "Subscription", "Payment"]}
        paths={["/", "/subscription", "/payment"]}
      />
      <BorderContainer active>
        <h2 className="font-bold text-[28px]">Payment Method</h2>
        <div className="md:flex justify-between items-center">
          <div>
            <p className="mt-5 text-base">
              Your next bill will be $489.00 and will arrive on 10/24/22
            </p>
            <div className="flex justify-start items-center py-5 gap-4 ">
              <img
                className="h-7 border-2 px-3 py-1 rounded"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Mastercard_2019_logo.svg/1200px-Mastercard_2019_logo.svg.png"
                alt="logo-card"
              />
              <div className="text-base">
                <p>MasterCard card ending in 7079</p>
                <p className="text-[#727272] text-[15px]">
                  Expiration: 07/2030
                </p>
              </div>
            </div>
          </div>
          <button className="bg-gr block mx-auto md:mx-0 px-7 py-2 font-semibold text-base bg-transparent text-[#338CC7] rounded-[12px] border border-[#338CC7]">
            Update
          </button>
        </div>
      </BorderContainer>
    </div>
  );
};
